import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import api from '@/lib/api';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Small dashboard chip surfacing revenue/records that were saved without a
 * branch. Taps straight through to the Reconcile Unassigned wizard so the
 * user can clean up that money. Renders nothing when everything is assigned.
 */
export default function UnassignedRevenueChip() {
  const navigate = useNavigate();
  const { cur } = useLanguage();
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get('/branches/unassigned-summary')
      .then(r => { if (alive) setData(r.data); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!data || !data.total_count) return null;

  const money = (typeof cur === 'function' ? cur() : 'SR');

  return (
    <button
      type="button"
      onClick={() => navigate('/reconcile-unassigned')}
      data-testid="dashboard-unassigned-chip"
      className="inline-flex items-center gap-2 rounded-full border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-800 shadow-sm transition-all hover:bg-amber-100 hover:shadow dark:border-amber-800/60 dark:bg-amber-950/30 dark:text-amber-300 dark:hover:bg-amber-900/40"
      title="Assign these records to a branch"
    >
      <AlertTriangle size={13} className="shrink-0" />
      <span>
        Unassigned: {money} {Number(data.sales_amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        <span className="ml-1 opacity-70">({data.total_count} records)</span>
      </span>
      <span className="ml-1 font-semibold underline underline-offset-2">Fix →</span>
    </button>
  );
}
